import React from 'react';
import PropTypes from 'prop-types';

const StepsContainer = ({ children, currentStep, stepClass }) => {
  const currentChild = React.Children.toArray(children)[currentStep];

  if (React.isValidElement(currentChild)) {
    return <div className={stepClass}>{currentChild}</div>;
  }

  return currentChild;
};

StepsContainer.propTypes = {
  children: PropTypes.node,
  stepClass: PropTypes.string,
  currentStep: PropTypes.number.isRequired,
};

export default StepsContainer;
